import { constructEnum } from '@/lib/enum';

export default constructEnum('ReviewSort', {
  MOST_LIKES: 10,
  MOST_HELPS: 15,
  MOST_TOTAL_HELPS: 16,
  RECENTLY_CREATED: 20,
  MOST_SCORES: 30,
  ALPHABETICAL: 40,
  MOST_REVIEWED: 50,
  AI_RECOMMENDATION: 80,
  OLDEST_PURCHASED: 90,
  RECENTLY_PURCHASED: 100,
  EXPIRES_SOON: 110
});
